import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { debugLogger } from '@/utils/debugLogger';
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    debugLogger.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-black to-gray-900 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="bg-black/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="bg-luxury-red/20 p-6 rounded-full border border-luxury-red/30">
              <Search className="h-16 w-16 text-luxury-red" />
            </div>
          </div>
          
          {/* Error Code */}
          <h1 className="text-6xl font-bold text-white mb-4">
            404
          </h1>
          
          {/* Title */}
          <h2 className="text-2xl font-semibold text-white mb-4">
            Página não encontrada
          </h2>
          
          {/* Description */}
          <p className="text-white/70 mb-2 leading-relaxed">
            A página que você está procurando não existe ou foi movida.
          </p>
          
          <p className="text-white/50 text-sm mb-8">
            Verifique a URL ou navegue para uma das nossas páginas principais.
          </p>
          
          {/* Action Button */}
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/main/feed')} 
              className="w-full bg-luxury-red hover:bg-luxury-red/90 text-white font-medium py-3 rounded-lg transition-colors"
            >
              <Home className="h-4 w-4 mr-2" />
              Ir para o Feed
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
